import React from 'react';
import { Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import CustomButton from '../shared/CustomButton';

const AddCapstoneLayout = ({ showAddCapstone, clickCheckinFn, clickFn, clickTakeawayFn }) => {
  const journeyDetails = useSelector((state) => state.JourneyDetails.journeydetails);
  const capstoneDetails = useSelector((state) => state.getCapstoneDetails);

  return (
    <Grid container spacing={1} style={{ padding: '12px' }}>
      {showAddCapstone && !capstoneDetails.capstonedetails && (
        <Grid item>
          <CustomButton variant="outlined" type="primary" label="+ Add Capstone" onClick={clickFn} size="large" />
        </Grid>
      )}

      {!journeyDetails.checkinId && journeyDetails.guidesCount + journeyDetails.capstoneActivitiesCount > 0 && (
        <Grid item>
          <CustomButton
            variant="outlined"
            type="primary"
            label="+ Add Check-in"
            onClick={clickCheckinFn}
            size="large"
          />
        </Grid>
      )}

      {journeyDetails?.journeyTakeaways === 0 && showAddCapstone && (
        <Grid item>
          <CustomButton
            variant="outlined"
            type="primary"
            label="+ Add Takeaways"
            onClick={clickTakeawayFn}
            size="large"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default AddCapstoneLayout;
